import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { SiteContextProvider } from '../context';

import ROUTES from './constants';

const Home = React.lazy(() => import('../pages/Site/Home/Home'));
const ChangePassword = React.lazy(() =>
  import('../pages/Site/ChangePassword/ChangePassword'),
);

export const SiteRoutes = () => (
  <SiteContextProvider>
    <Switch>
      <Route path={ROUTES.SITE.HOME} component={Home} exact />
      <Route
        path={ROUTES.SITE.CHANGE_PASSWORD}
        component={ChangePassword}
        exact
      />
    </Switch>
  </SiteContextProvider>
);

export default SiteRoutes;
